import { DetailCards } from 'components/detail/view/DetailCards';
import { DetailHeader, S_Content } from 'components/detail/view/DetailHeader';
import { FAQ } from 'components/guide/faq/FAQ';
import { useContext } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const EventViewInformationPageContent = (props: Props) => {
    const ctxEventView = useContext(CtxEventView);
    const { informationList } = ctxEventView;

    return (
        <S_EVInformationPageContent className={props.className}>
            <FAQ
                topics={informationList.map((info) => {
                    return {
                        q: info.title,
                        a: (
                            <>
                                {info.description && (
                                    <S_DetailHeader
                                        header={{
                                            title: info.title,
                                            text: info.description,
                                            imageUrl: null,
                                            imageStyleId: null
                                        }}
                                        skipTitle={true}
                                    />
                                )}
                                {info.storyCards?.length > 0 && (
                                    <S_DetailCards cards={info.storyCards} noMarginBottom />
                                )}
                            </>
                        )
                    };
                })}
                isWide={ctxEventView.isWide}
            />
        </S_EVInformationPageContent>
    );
};

const S_EVInformationPageContent = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;

const S_DetailHeader = styled(DetailHeader)`
    background-color: unset;
    box-shadow: unset;
    width: 100%;
    padding-left: 0;
    padding-right: 0;
    ${S_Content} {
        padding: 10px 0 0 0;
    }
`;

const S_DetailCards = styled(DetailCards)`
    background-color: unset;
    box-shadow: unset;
    width: 100%;
    padding: 0 0 0px 0;
`;
